import { Search, X } from 'lucide-react'
import './SearchBox.css'

/** The one search field style, design.md 8.9. */
export function SearchBox({
  value,
  onChange,
  placeholder = 'Search…',
  label,
  width,
}: {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  /** The accessible name, when the placeholder alone isn't one. */
  label?: string
  width?: number | string
}) {
  return (
    <div className="search-box" role="search" style={width ? { width } : undefined}>
      <Search aria-hidden="true" />
      <input type="search" value={value} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} aria-label={label ?? placeholder} />
      {value && (
        <button type="button" className="search-clear" onClick={() => onChange('')} aria-label="Clear search">
          <X aria-hidden="true" />
        </button>
      )}
    </div>
  )
}
